module.exports = __webpack_public_path__ + "static/media/jbeiber.7b0dfea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/jbeiber.jpg
// module id = 21
// module chunks = 0